export const headerConfig = {
  headerTitle: 'Pending Payments',
  headerDescription: 'List of Pending Payments',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
